import React, { type FormEvent, useState } from 'react'
import { Form } from 'react-bootstrap'
import { Button } from '../../../../components/Button/Button'
import { InfoBox } from '../../../../components/InfoBox/InfoBox'
import { isValidUrl } from '../../../../common/urlValidation'
import { DEVELOPER_DOCS_URL } from '../../constants'
import { RedirectUrisFormFields } from '../../components/RedirectUrisFormFields'
import { type RedirectUri, toRedirectUris } from '../../components/redirectUri'

interface RedirectUrisStepProps {
  initialUris: string[]
  onNext: (uris: string[]) => void
  onBack: () => void
}

export const RedirectUrisStep: React.FC<RedirectUrisStepProps> = ({ initialUris, onNext, onBack }) => {
  const [uris, setUris] = useState<RedirectUri[]>(() => toRedirectUris(initialUris.length > 0 ? initialUris : ['']))
  const [validated, setValidated] = useState(false)

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    setValidated(true)

    const nonEmptyUris = uris.map((uri) => uri.value).filter((value) => value.trim() !== '')
    if (nonEmptyUris.length === 0) {
      return
    }

    const allValid = nonEmptyUris.every((uri) => isValidUrl(uri))
    if (!allValid) {
      return
    }

    onNext(nonEmptyUris)
  }

  return (
    <Form noValidate validated={validated} onSubmit={handleSubmit}>
      <h5 className='fw-bold mb-4'>Add redirect URIs</h5>

      <RedirectUrisFormFields uris={uris} setUris={setUris} validated={validated} />

      <div className='mt-3'>
        <InfoBox variant='info'>
          <span className='paragraph-medium'>
            Read the guide to learn more about how to set up Redirect URIs.{' '}
            <a
              href={`${DEVELOPER_DOCS_URL}docs/guides/start-building/getting-started`}
              target='_blank'
              rel='noopener noreferrer'
              className='fw-bold text-decoration-underline zocks-text-gray-900'
            >
              Setup guide
            </a>
          </span>
        </InfoBox>
      </div>

      <div className='d-flex justify-content-end gap-3 mt-4'>
        <Button variant='secondary' className='fw-bold' onClick={onBack}>
          Back
        </Button>
        <Button type='submit' variant='primary' className='fw-bold'>
          Next
        </Button>
      </div>
    </Form>
  )
}
